import { AfterViewInit, Component, ElementRef, EventEmitter, NgZone, OnDestroy, Output, ViewChild } from '@angular/core';
import { BrowserMultiFormatReader } from '@zxing/library';

@Component({
  selector: 'app-qr-code-scanner',
  standalone: true,
  imports: [],
  templateUrl: './qr-code-scanner.component.html',
  styleUrl: './qr-code-scanner.component.scss',
})
export class QrCodeScannerComponent implements AfterViewInit, OnDestroy {
  @Output() public scanSuccess: EventEmitter<string> = new EventEmitter<string>();
  @Output() public closed: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild('scannerVideo') private scannerVideo?: ElementRef<HTMLVideoElement>;

  private codeReader: BrowserMultiFormatReader = new BrowserMultiFormatReader();

  constructor(private ngZone: NgZone) { }

  ngAfterViewInit(): void {
    this.initScanner();
  }

  private initScanner(deviceId?: string): void {
    if (!this.scannerVideo) return;

    const constraints: MediaStreamConstraints = deviceId
      ? { video: { deviceId: { exact: deviceId } } }
      : { video: { facingMode: { exact: 'environment' } } };

    this.codeReader.decodeFromConstraints(
      constraints,
      this.scannerVideo.nativeElement,
      (result) => {
        if (result) {
          this.ngZone.run(() => {
            this.scanSuccess.emit(result.getText());
            this.stopScanner();
          });
        }
      }
    )
      .then(() => { })
      .catch(() => {
        if (!deviceId) {
          this.initScanner('');
        }
      });
  }

  public stopScanner(): void {
    this.codeReader.reset();
  }

  public close(): void {
    this.stopScanner();
    this.closed.emit();
  }

  ngOnDestroy(): void {
    this.codeReader.reset();
  }
}
